import { observer } from "mobx-react";
import React from "react";
import OfferIcon from "@components/icons/Offer";
import { useTranslation } from "react-i18next";
import { ChatMessageType } from "@data-types/chat";
import { useRootAppStore } from "@hooks";

export default observer(function ChatReplayMessagePreview() {
	const rootStore = useRootAppStore();
	const { t } = useTranslation();

	const { selectedMessageToReplyOn } = rootStore.chatViewStore;

	if (!selectedMessageToReplyOn) {
		return null;
	}

	const creatorId =
		selectedMessageToReplyOn.creatorId !==
		rootStore.userAuthStore.user?.chatName
			? selectedMessageToReplyOn.creatorId
			: `${t("CHAT.REPLIED_TO_NAME")}`;

	if (
		!selectedMessageToReplyOn.data.betSlipData &&
		!selectedMessageToReplyOn.data.sharedSlip
	) {
		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>
					<i
						className="chat__reply__close u-icon u-icon--tny u-icon--close"
						onClick={() => {
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							);
						}}
					/>
				</div>
				<span className="chat__reply__message">
					{selectedMessageToReplyOn.data?.text}
				</span>
			</div>
		);
	}

	if (
		selectedMessageToReplyOn.data.sharedSlip &&
		selectedMessageToReplyOn.data.betSlipData
	) {
		const {
			eventCount,
			maxCoefficient,
			dateCreated,
			sportAbrv,
			firstEventName,
		} = selectedMessageToReplyOn.data.betSlipData;

		const isMultiOffer =
			selectedMessageToReplyOn.data?.betSlipData.hasBetBuilder;

		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>
					<i
						className="chat__reply__close u-icon u-icon--tny u-icon--close"
						onClick={() =>
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							)
						}
					/>
				</div>

				<p className="chat__reply__message">
					{selectedMessageToReplyOn.data.text}
				</p>

				<div className="chat__reply__slip">
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>
						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--base"></i>
						)}
						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</div>
		);
	}

	if (
		selectedMessageToReplyOn.data.messageType == ChatMessageType.REPLY &&
		selectedMessageToReplyOn.data.sharedSlip &&
		!selectedMessageToReplyOn.data.betSlipData
	) {
		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>
					<i
						className="chat__reply__close u-icon u-icon--tny u-icon--close"
						onClick={() =>
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							)
						}
					/>
				</div>

				<p className="chat__reply__message">
					{selectedMessageToReplyOn.data?.text}
				</p>
			</div>
		);
	}

	if (
		selectedMessageToReplyOn.data.messageType != ChatMessageType.REPLY &&
		selectedMessageToReplyOn.data.sharedSlip &&
		!selectedMessageToReplyOn.data.betSlipData
	) {
		const {
			eventCount,
			maxCoefficient,
			dateCreated,
			sportAbrv,
			firstEventName,
		} = selectedMessageToReplyOn.data.sharedSlip;

		const messageText = selectedMessageToReplyOn.data.text;

		const isMultiOffer = selectedMessageToReplyOn.metadata?.isMultiOffer;

		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<p className="chat__reply__username">{creatorId}:</p>
					<i
						className="chat__reply__close u-icon u-icon--tny u-icon--close"
						onClick={() =>
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							)
						}
					/>
				</div>

				<p className="chat__reply__message">{messageText}</p>

				<div className="chat__reply__slip">
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>
						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--base"></i>
						)}
						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</div>
		);
	}

	if (
		!selectedMessageToReplyOn.data.sharedSlip &&
		selectedMessageToReplyOn.data.betSlipData
	) {
		const {
			eventCount,
			maxCoefficient,
			dateCreated,
			sportAbrv,
			firstEventName,
		} = selectedMessageToReplyOn.data.betSlipData;

		const isMultiOffer =
			selectedMessageToReplyOn.data.betSlipData?.hasBetBuilder;

		const messageText = selectedMessageToReplyOn.data.text;

		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<p className="chat__reply__username">{creatorId}:</p>

					<i
						className="chat__reply__close u-icon u-icon--tny u-icon--close"
						onClick={() => {
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							);
						}}
					/>
				</div>

				<p className="chat__reply__message">{messageText}</p>

				<div className="chat__reply__slip">
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>
						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--base"></i>
						)}
						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</div>
		);
	}

	return <></>;
});
